import { ObjectStackItem } from './ObjectStackItem';
export class EquatableKeyStackItem extends ObjectStackItem {
    toStructuralKey() {
        return this.value.toKeyString();
    }
    equals(other) {
        if (other === undefined) {
            return false;
        }
        if (this === other) {
            return true;
        }
        return other instanceof EquatableKeyStackItem && this.value.equals(other.value);
    }
}

//# sourceMappingURL=EquatableKeyStackItem.js.map
